import "./form.css";

const Form = () => {
    return (
        <form 
            action="https://formspree.io/f/mlgejwwd"
            method="POST"
            className="form"
        >
            <div className="form-inner">
                <h2 className="home-h2">Get a Free Quote and Get the Work Done </h2>
                <p className="home-p">Please complete the short form below to receive your free quotation. 
                   Our friendly and professional customer care representatives are here 
                   to assist you and answer any questions you may have.
                </p>

                <div className="form-row">
                    <label>Name<input className="form-input" type="text" name="name" autoComplete="name" pattern="[A-Za-z\s\-']{2,50}" required /></label>
                    <label>Phone<input className="form-input" type="tel" name="phone" autoComplete="tel" pattern="04[0-9]{8}" required /></label>
                </div>
                
                <div className="form-row">
                    <label>Email<input className="form-input" type="email" name="email" autoComplete="email" required /></label>
                    <label>Suburb<input className="form-input" type="text" name="suburb" autoComplete="address-level2" pattern="[A-Za-z\s\-']{2,30}" required /></label>
                </div>

                <div className="form-row message-row">
                    <label htmlFor="quote-message">Describe your job
                        <textarea className="form-textarea" id="quote-message" name="message" />
                    </label>
                </div>
                
                <button type="submit">Get Your Free Quote</button>
            </div>
            
        </form>
    )
}

export default Form;
